import itemInstance from "./itemInstance";

export default (entity = {}) => {
    return {
        id: entity.id || undefined,
        menuId: entity.menuId,
        name: entity.name || '',
        description: entity.description || '',
        note: entity.note || null,
        posId: entity.posId || null,
        type: entity.type || 'primary',
        options: entity.options || {},
        limit: entity.limit || null,
        triggers: entity.triggers || null,
        sortIndex: entity.sortIndex || null,
        imageGuid: entity.imageGuid || undefined,
        imageUrl: entity.imageUrl || undefined,
        primaryParentId: entity.primaryParentId || null,
        subcategoriesIds: entity.subcategoriesIds || [],
        itemsInstancesToAdd: entity.itemsInstancesToAdd && entity.itemsInstancesToAdd.map(i => itemInstance(i)) || undefined,
        availability: entity.availability || {
            day1Allowed: entity.hasOwnProperty('day1Allowed') ? entity.day1Allowed : 'true',
            day2Allowed: entity.hasOwnProperty('day2Allowed') ? entity.day2Allowed : 'true',
            day3Allowed: entity.hasOwnProperty('day3Allowed') ? entity.day3Allowed : 'true',
            day4Allowed: entity.hasOwnProperty('day4Allowed') ? entity.day4Allowed : 'true',
            day5Allowed: entity.hasOwnProperty('day5Allowed') ? entity.day5Allowed : 'true',
            day6Allowed: entity.hasOwnProperty('day6Allowed') ? entity.day6Allowed : 'true',
            day7Allowed: entity.hasOwnProperty('day7Allowed') ? entity.day7Allowed : 'true',
        },
        isDisabled: entity.isDisabled || false,
    };
};
